import { requestJson } from "./http";

function getProp(obj, camel, pascal) {
  if (!obj) return undefined;
  return obj[camel] ?? obj[pascal];
}

function normalizeDepartment(d) {
  if (!d) return null;
  return {
    departmentId: getProp(d, "departmentId", "DepartmentId"),
    hospitalId: getProp(d, "hospitalId", "HospitalId"),
    name: getProp(d, "name", "Name"),
    createdUtc: getProp(d, "createdUtc", "CreatedUtc"),
    updatedUtc: getProp(d, "updatedUtc", "UpdatedUtc"),
  };
}

export function normalizeHospitalOption(hospital) {
  if (!hospital) return null;
  const rawDepts = getProp(hospital, "departments", "Departments");
  return {
    hospitalId: getProp(hospital, "hospitalId", "HospitalId"),
    name: getProp(hospital, "name", "Name"),
    isActive: getProp(hospital, "isActive", "IsActive"),
    useExactShiftTimes: getProp(hospital, "useExactShiftTimes", "UseExactShiftTimes") ?? false,
    createdUtc: getProp(hospital, "createdUtc", "CreatedUtc"),
    updatedUtc: getProp(hospital, "updatedUtc", "UpdatedUtc"),
    departments: Array.isArray(rawDepts)
      ? rawDepts.map(normalizeDepartment).filter(Boolean)
      : [],
  };
}

export async function fetchHospitalOptions(signal) {
  const data = await requestJson("/api/hospitals", { signal });
  return Array.isArray(data)
    ? data.filter(Boolean).map(normalizeHospitalOption)
    : [];
}
